import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoModule,
  TranslocoService,
} from '@ngneat/transloco';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco.http-loader';
import { environment } from 'src/environments/environment';
// import { environment } from '/environments/environment';
// import { TranslocoHttpLoader } from '/src/app/transloco/transloco.http-loader';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      // Provide the default Transloco configuration
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: [
          {
            id: 'en',
            label: 'English',
          },
          {
            id: 'fa',
            label: 'Persian',
          },
        ],
        defaultLang: 'fa',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      }),
    },
    {
      // Provide the default Transloco loader
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader,
    },
    {
      // Preload the default language before the app starts to prevent empty/jumping content
      provide: APP_INITIALIZER,
      deps: [TranslocoService],
      useFactory:
        (translocoService: TranslocoService): any =>
        (): Promise<Translation> => {
          // load language from local storage
          const language = localStorage.getItem('language');

          if (language) {
            translocoService.setActiveLang(language);
            if (language === 'fa') {
              document
                .getElementsByTagName('html')[0]
                .setAttribute('dir', 'rtl');
            } else {
              document.getElementsByTagName('html')[0].removeAttribute('dir');
            }
            return translocoService.load(language).toPromise();
          } else {
            const defaultLang = translocoService.getDefaultLang();
            translocoService.setActiveLang(defaultLang);
            document
            .getElementsByTagName('html')[0]
            .setAttribute('dir', 'rtl');
            return translocoService.load(defaultLang).toPromise();
          }
        },
      multi: true,
    },
  ],
})
export class TranslocoCoreModule {}
